'use strict';

// Selectors
var TIME_SINCE_PUBLISHED = '[data-time-since-published]';
var KNOWLEDGE_TOPIC = '[data-knowledge-topic]';

// if single topic page
isTopicPage().then(function (publishedDate) {

  unwrapImages();
  setTimeSincePublished(publishedDate);
  onVoteButtonClicked(updateAccentuateRecord);

  function onVoteButtonClicked(func) {
    $('[data-topic-vote-up]').on('click touch', function () {
      return func('up');
    });
    $('[data-topic-vote-down]').on('click touch', function () {
      return func('down');
    });
  }

  function updateAccentuateRecord(voteDirection) {
    console.log('Submit vote has not been implemented');
  }

  function unwrapImages() {
    $(KNOWLEDGE_TOPIC + ' p > img').unwrap();
  }
});

// if topic list page
isTopicListPage().then(function () {
  $(KNOWLEDGE_TOPIC).each(function (i, topic) {
    return setTimeSincePublished(topic.dataset.publishedDate);
  });
});

function setTimeSincePublished(publishedDate) {
  var sincePublishedString = void 0;

  var millisecondsSincePublished = Math.abs(new Date() - new Date(publishedDate));

  var diffDays = Math.ceil(millisecondsSincePublished / (1000 * 60 * 60 * 24));
  if (diffDays == 0) {
    sincePublishedString = 'Published today';
  } else if (diffDays < 7) {
    sincePublishedString = diffDays + ' ' + (diffDays == 1 ? 'day' : 'days') + ' ago';
  } else if (diffDays < 28) {
    var weeks = Math.round(diffDays / 7);
    sincePublishedString = weeks + ' ' + (weeks == 1 ? 'week' : 'weeks') + ' ago';
  } else {
    var months = Math.round(diffDays / 30);
    sincePublishedString = months + ' ' + (months == 1 ? 'month' : 'months') + ' ago';
  }

  $(TIME_SINCE_PUBLISHED).text(sincePublishedString);
}

function isTopicPage() {
  return new Promise(function (resolve, reject) {
    return $(function () {
      var topicContainer = document.querySelector(KNOWLEDGE_TOPIC);
      !!topicContainer ? resolve(topicContainer.dataset.publishedDate) : reject();
    });
  });
}

function isTopicListPage() {
  return new Promise(function (resolve, reject) {
    return $(function () {
      return !!document.querySelector(KNOWLEDGE_TOPIC) ? resolve() : reject();
    });
  });
}